import { render } from "./gameEntry.vue?vue&type=template&id=2cabab23&scoped=true"
import script from "./gameEntry.vue?vue&type=script&lang=js"
export * from "./gameEntry.vue?vue&type=script&lang=js"

import "./gameEntry.vue?vue&type=style&index=0&id=2cabab23&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cabab23"]])

export default __exports__